import React, { useState, useEffect, useRef } from "react";
import { Link, Outlet } from "react-router-dom";
import { FaEdit } from "react-icons/fa";
import { FaTrashCan } from "react-icons/fa6";
import BulkExport from "../../ActiveBuyerList/Component/BulkButton/BulkExport";

const ReviewAndRatings = () => {
  //Mulitiple Dropdowns
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [isSelectOpen, setIsSelectOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isActionOpen, setIsActionOpen] = useState(false);


  const closeSuccessModal = () => {
    setShowSuccessModal(false);
  };
  const dropdownRef = useRef(null);
  // bulk import popup
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [file, setFile] = useState(null);

  // Handle file selection
  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };
  // Handle file upload
  const handleUpload = () => {
    if (file) {
      // Handle file upload logic here
      console.log("File uploaded:", file);
      setIsPopupOpen(false); // Close popup after upload
    }
  };

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsFilterOpen(false);
        setIsSelectOpen(false);
        setIsMenuOpen(false);
        setIsActionOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [data, setData] = useState([
    {
      seller: "Emayam Technology",
      review: "Good and Quality",
      rating: "★★★☆☆",
      complaints: "None",
      feedbacks: "None",
      dateOfReview: "31/11/2024",
      lastEdited: "31/11/2024",
      action: { edit: true, delete: true },
    },
    {
      seller: "Emayam Technology",
      review: "Good and Quality",
      rating: "★★★☆☆",
      complaints: "None",
      feedbacks: "None",
      dateOfReview: "31/11/2024",
      lastEdited: "31/11/2024",
      action: { edit: true, delete: true },
    },
    {
      seller: "Emayam Technology",
      review: "Good and Quality",
      rating: "★★★☆☆",
      complaints: "None",
      feedbacks: "None",
      dateOfReview: "31/11/2024",
      lastEdited: "31/11/2024",
      action: { edit: true, delete: true },
    },
    {
      seller: "Emayam Technology",
      review: "Good and Quality",
      rating: "★★★☆☆",
      complaints: "None",
      feedbacks: "None",
      dateOfReview: "31/11/2024",
      lastEdited: "31/11/2024",
      action: { edit: true, delete: true },
    },
    {
      seller: "Emayam Technology",
      review: "Good and Quality",
      rating: "★★★☆☆",
      complaints: "None",
      feedbacks: "None",
      dateOfReview: "31/11/2024",
      lastEdited: "31/11/2024",
      action: { edit: true, delete: true },
    },
    {
      seller: "Emayam Technology",
      review: "Good and Quality",
      rating: "★★★☆☆",
      complaints: "None",
      feedbacks: "None",
      dateOfReview: "31/11/2024",
      lastEdited: "31/11/2024",
      action: { edit: true, delete: true },
    },
    {
      seller: "Emayam Technology",
      review: "Good and Quality",
      rating: "★★★☆☆",
      complaints: "None",
      feedbacks: "None",
      dateOfReview: "31/11/2024",
      lastEdited: "31/11/2024",
      action: { edit: true, delete: true },
    },
    {
      seller: "Emayam Technology",
      review: "Good and Quality",
      rating: "★★★☆☆",
      complaints: "None",
      feedbacks: "None",
      dateOfReview: "31/11/2024",
      lastEdited: "31/11/2024",
      action: { edit: true, delete: true },
    },
    {
      seller: "Emayam Technology",
      review: "Good and Quality",
      rating: "★★★☆☆",
      complaints: "None",
      feedbacks: "None",
      dateOfReview: "31/11/2024",
      lastEdited: "31/11/2024",
      action: { edit: true, delete: true },
    },
    {
      seller: "Emayam Technology",
      review: "Good and Quality",
      rating: "★★★☆☆",
      complaints: "None",
      feedbacks: "None",
      dateOfReview: "31/11/2024",
      lastEdited: "31/11/2024",
      action: { edit: true, delete: true },
    },
  ]);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [idSearch, setIdSearch] = useState("");
  const [statusSearch, setStatusSearch] = useState("");
  const [companySearch, setCompanySearch] = useState("");
  const [emailSearch, setEmailSearch] = useState("");
  const [phoneSearch, setPhoneSearch] = useState("");
  const [locationSearch, setLocationSearch] = useState("");

  const getStatusClass = (status) => {
    switch (status) {
      case "Active":
        return "bg-[#e1fcef] text-[#38a06c]";
      case "DeActive":
        return "bg-[#ffedef] text-[#d12a3e]";
      case "On Hold":
        return "bg-[#e9edf5] text-[#5a6376]";
      case "Premium":
        return "bg-[#fcf2e6] text-[#c97a20]";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  const handleSelectAll = () => {
    setSelectAll(!selectAll);
    setSelectedRows(!selectAll ? data.map((row) => row.id) : []);
  };
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const handleRowSelect = (id) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };

  const filteredData = data.filter((row) => {
    const matchesId = idSearch
      ? row.id.toLowerCase().includes(idSearch.toLowerCase())
      : true;
    const matchesStatus = statusSearch
      ? row.complaints.toLowerCase().includes(statusSearch.toLowerCase())
      : true;
    const matchesCompany = companySearch
      ? row.seller.toLowerCase().includes(companySearch.toLowerCase())
      : true;
    const matchesEmail = emailSearch
      ? row.review.toLowerCase().includes(emailSearch.toLowerCase())
      : true;
    const matchesPhone = phoneSearch
      ? row.phone.toLowerCase().includes(phoneSearch.toLowerCase())
      : true;
    const matchesLocation = locationSearch
      ? row.location.toLowerCase().includes(locationSearch.toLowerCase())
      : true;
    return (
      matchesId &&
      matchesStatus &&
      matchesCompany &&
      matchesEmail &&
      matchesPhone &&
      matchesLocation
    );
  });

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const [isPopOpen, setIsPopOpen] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const confirmDelete = () => {
    setShowDeleteModal(false);
    setTimeout(() => {
      setShowSuccessModal(true);
    }, 300);
  };
  const [showSuccessModal1, setShowSuccessModal1] = useState(false);

  return (
    <div className=" w-full">
      <div className="overflow-x-auto w-full">
        <div className="overflow-hidden rounded-lg border-2 border-gray-200 w-full">
          <div className="">
            <h1 className="text-xl text-[#667085] w-full p-4 border-b">
              Review and Ratings
            </h1>
          </div>

          <div className="flex items-center justify-between px-4">
            <div className="flex gap-6">
              <h1 className="text-[#667085] text-base font-medium">
                <span className="text-oceanBlue">Total Review and Rating : </span>
                50
              </h1>

            </div>
            <div className="flex items-center">
              <div>
                <div className="flex gap-3 my-3">
                  <BulkExport content={" Export"} />
                  <Pagination />
                </div>
              </div>
            </div>
          </div>

          <table className="w-full table-auto border-collapse overflow-x-auto ">
            <thead className="bg-[#eeee] ">
              <tr>
                <th className="p-3 border-2 border-gray-200 font-medium text-gray-500 mx-auto">
                  OSP/Seller
                </th>

                <th className="p-3 border-2 border-gray-200 font-medium text-gray-500 text-left">
                  Review
                </th>
                <th className="p-3 border-2 border-gray-200 font-medium text-gray-500 text-left">
                  Ratings
                </th>
                <th className="p-3 border-2 border-gray-200 font-medium text-gray-500 text-left">
                  Complaints
                </th>
                <th className="p-3 border-2 border-gray-200 font-medium text-gray-500 text-left">
                  Feedbacks
                </th>
                <th className="p-3 border-2 border-gray-200 font-medium text-gray-500 text-left">
                  Date of Review
                </th>
                <th className="p-3 border-2 border-gray-200 font-medium text-gray-500 text-left">
                  Last Edited
                </th>
                <th className="p-3 border-2 border-gray-200 font-medium text-gray-500 text-left">
                  Actiion
                </th>
              </tr>
              <tr>
                <th className="p-3 border-2 border-gray-200 text-left">
                  <input
                    placeholder="Search Seller"
                    className="w-full bg-white outline-gray-200 px-3 py-1 text-gray-500 rounded-md font-normal"
                    type="search"
                    value={companySearch}
                    onChange={(e) => setCompanySearch(e.target.value)}
                  />
                </th>
                <th className="p-3 border-2 border-gray-200 text-left">
                  <input
                    placeholder="Review"
                    className="w-full bg-white outline-gray-200 px-3 py-1 text-gray-500 rounded-md font-normal"
                    type="search"
                    value={emailSearch}
                    onChange={(e) => setEmailSearch(e.target.value)}
                  />
                </th>
                <th className="p-3 border-2 border-gray-200 text-left">
                  <input
                    placeholder="Ratings"
                    className="w-full bg-white outline-gray-200 px-3 py-1 text-gray-500 rounded-md font-normal"
                    type="search"
                    value={phoneSearch}
                    onChange={(e) => setPhoneSearch(e.target.value)}
                  />
                </th>
                <th className="p-3 border-2 border-gray-200 text-left">
                  <input
                    placeholder="Complaints"
                    className="w-full bg-white outline-gray-200 px-3 py-1 text-gray-500 rounded-md font-normal"
                    type="search"
                    value={statusSearch}
                    onChange={(e) => setPhoneSearch(e.target.value)}
                  />
                </th>
                <th className="p-3 border-2 border-gray-200 text-left">
                  <input
                    placeholder="Search Feedbacks"
                    className="w-full bg-white outline-gray-200 px-3 py-1 text-gray-500 rounded-md font-normal"
                    type="search"
                    value={phoneSearch}
                    onChange={(e) => setPhoneSearch(e.target.value)}
                  />
                </th>
                <th className="p-3 border-2 border-gray-200 text-left">
                  <input
                    placeholder="Search Date of Review"
                    className="w-full bg-white outline-gray-200 px-3 py-1 text-gray-500 rounded-md font-normal"
                    type="search"
                    value={phoneSearch}
                    onChange={(e) => setPhoneSearch(e.target.value)}
                  />
                </th>
                <th className="p-3 border-2 border-gray-200 text-left">
                  <input
                    placeholder="Last Edited"
                    className="w-full bg-white outline-gray-200 px-3 py-1 text-gray-500 rounded-md font-normal"
                    type="search"
                    value={phoneSearch}
                    onChange={(e) => setPhoneSearch(e.target.value)}
                  />
                </th>
                <th className="p-3 border-2 border-gray-200 text-left">
                  <input
                    placeholder=""
                    className="w-full bg-white outline-gray-200 px-3 py-1 text-gray-500 rounded-md font-normal"
                    type="search"
                    value={locationSearch}
                    onChange={(e) => setLocationSearch(e.target.value)}
                  />
                </th>
              </tr>
            </thead>
            <tbody>
              {currentData.map((row, index) => (
                <tr
                  key={index}
                  className={`bg-white  ${selectedRows.includes(row.id) ? "bg-[#f4f7fd]" : ""
                    }`}
                >
                  <td className="p-3 border-2 text-center border-gray-200">{row.seller.slice(0, 10) + ".."}</td>

                  <td className="p-3 border-2 text-center border-gray-200">{row.review.slice(0, 6) + ".."}</td>
                  <td className="p-3 border-2 text-center border-gray-200 text-[#FF731D] ">
                    {row.rating}
                  </td>
                  <td className="p-3 border-2 text-center border-gray-200">
                    {row.complaints}
                  </td>
                  <td className="p-3 border-2 text-center border-gray-200">
                    {row.feedbacks}
                  </td>
                  <td className="p-3 border-2 text-center border-gray-200">
                    {row.dateOfReview}
                  </td>
                  <td className="p-3 border-2 text-center border-gray-200">
                    {row.lastEdited}
                  </td>
                  <td className="border border-gray-300 text-center px-4 py-2">
                    <div className="flex">
                      <button className="bg-[#494F55] text-white p-2 rounded mr-2">
                        <button onClick={() => setIsPopOpen(true)} >
                          <FaEdit />
                        </button>
                      </button>
                      <button className="bg-blood text-white p-2 rounded">
                        <button onClic onClick={() => setShowDeleteModal(true)} >
                          <FaTrashCan />
                        </button>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <Outlet />
        </div>
        <div className="mt-3">
          <Pagination />
        </div>

        {isPopOpen && <ParticleText setIsPopOpen={setIsPopOpen} isPopOpen={isPopOpen}  setShowSuccessModal1={setShowSuccessModal1} showSuccessModal1={showSuccessModal1}/>}
        {showDeleteModal && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded-lg shadow-lg text-center w-80">
              <div className="text-4xl text-red-600 mb-4">❓</div>
              <p className="mb-6 text-lg font-medium">
                Do you want to delete this Review and Ratings?
              </p>
              <div className="flex justify-center gap-4">
                <button
                  onClick={() => setShowDeleteModal(false)}
                  className="px-6 py-2 border border-red-600 text-red-600 rounded hover:bg-red-50"
                >
                  Cancel
                </button>
                <button
                  onClick={confirmDelete}
                  className="px-6 py-2 bg-red-600 text-white rounded hover:bg-red-700"
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        )}



        {showSuccessModal && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded-lg shadow-lg text-center w-80">
              <div className="text-4xl text-green-600 mb-4">✅</div>
              <p className="mb-4 text-lg font-medium">
                Review and Ratings Deleted Successfully!!! ✅
              </p>
              <button
                onClick={closeSuccessModal}
                className="px-6 py-2 bg-red-600 text-white rounded hover:bg-red-700"
              >
                Done
              </button>
            </div>
          </div>
        )}

        {showSuccessModal1 && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg text-center w-80">
            <div className="text-4xl text-green-600 mb-4">✅</div>
            <p className="mb-4 text-lg font-medium">Review and Ratings Saved Successfully! ✅</p>
            <button
              onClick={() => setShowSuccessModal1(false)}
              className="px-6 py-2 bg-red-600 text-white rounded hover:bg-red-700"
            >
              Done
            </button>
          </div>
        </div>
      )}
      </div>
    </div>
  );
};

export default ReviewAndRatings;


function Pagination() {
  const [pageSize, setPageSize] = useState(20);

  const handlePageSize = (value) => {
    setPageSize(Number(value));
  };
  return (
    <div>
      {/* Pagination */}
      <div
        className={`border w-fit border-gray-300 border-collapse rounded text-gray-500 flex items-center opacity-100 group-hover:cursor-pointer`}
      >
        <div
          className={`py-1 px-2 opacity-100 hover:cursor-pointer border-r border-gray-300 ${pageSize === 20 ? "bg-blue-600 text-white rounded" : ""
            }`}
          onClick={(e) => handlePageSize(e.currentTarget.textContent)}
        >
          20
        </div>
        <div
          className={`py-1 px-2 opacity-100 hover:cursor-pointer border-r border-gray-300 ${pageSize === 100 ? "bg-blue-600 text-white" : ""
            }`}
          onClick={(e) => handlePageSize(e.currentTarget.textContent)}
        >
          100
        </div>
        <div
          className={`py-1 px-2 opacity-100 hover:cursor-pointer border-r border-gray-300 ${pageSize === 500 ? "bg-blue-600 text-white" : ""
            }`}
          onClick={(e) => handlePageSize(e.currentTarget.textContent)}
        >
          500
        </div>
        <div
          className={`py-1 px-2 opacity-100 hover:cursor-pointer border-r border-gray-300 ${pageSize === 2500 ? "bg-blue-600 text-white" : ""
            }`}
          onClick={(e) => handlePageSize(e.currentTarget.textContent)}
        >
          2500
        </div>
        <div
          className={`py-1 px-2 opacity-100 hover:cursor-pointer ${pageSize === 5000 ? "bg-blue-600 text-white rounded" : ""
            }`}
          onClick={(e) => handlePageSize(e.currentTarget.textContent)}
        >
          5000
        </div>
      </div>


      {/*  */
      }


    </div>
  );
}






// --- SVG Icons (to keep the main component clean) ---

const StarIcon = (props) => (
  <svg {...props} fill="currentColor" viewBox="0 0 20 20">
    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.957a1 1 0 00.95.69h4.162c.969 0 1.371 1.24.588 1.81l-3.365 2.444a1 1 0 00-.364 1.118l1.286 3.957c.3.921-.755 1.688-1.539 1.118l-3.365-2.444a1 1 0 00-1.175 0l-3.365 2.444c-.784.57-1.838-.197-1.539-1.118l1.286-3.957a1 1 0 00-.364-1.118L2.05 9.384c-.783-.57-.38-1.81.588-1.81h4.162a1 1 0 00.95-.69l1.286-3.957z" />
  </svg>
);

const HalfStarIcon = (props) => (
  <svg {...props} fill="currentColor" viewBox="0 0 20 20">
    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.957a1 1 0 00.95.69h4.162c.969 0 1.371 1.24.588 1.81l-3.365 2.444a1 1 0 00-.364 1.118l1.286 3.957c.3.921-.755 1.688-1.539 1.118l-3.365-2.444a1 1 0 00-1.175 0l-3.365 2.444c-.784.57-1.838-.197-1.539-1.118l1.286-3.957a1 1 0 00-.364-1.118L2.05 9.384c-.783-.57-.38-1.81.588-1.81h4.162a1 1 0 00.95-.69l1.286-3.957z" />
  </svg>
);

const PremiumIcon = (props) => (
  <svg {...props} fill="currentColor" viewBox="0 0 20 20">
    <path d="M5 4a2 2 0 012-2h6a2 2 0 012 2v2a2 2 0 01-2 2H7a2 2 0 01-2-2V4z" />
    <path d="M5 12a2 2 0 012-2h6a2 2 0 012 2v2a2 2 0 01-2 2H7a2 2 0 01-2-2v-2z" />
  </svg>
);


const ParticleText = ({ isPopOpen, setIsPopOpen , showSuccessModal1, setShowSuccessModal1}) => {
  const [userRating, setUserRating] = useState(0);
  const [hoverRating, setHoverRating] = useState(0);

  const overallRating = 4.5;
  const totalReviews = 50200;
  const ratingDistribution = [
    { star: 5, count: 2123 },
    { star: 4, count: 1092 },
    { star: 3, count: 324 },
    { star: 2, count: 51 },
    { star: 1, count: 7 },
  ];
  const maxCount = Math.max(...ratingDistribution.map(r => r.count));

  const renderDisplayStars = (rating) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      if (i <= rating) {
        stars.push(<StarIcon key={i} className="w-5 h-5 text-orange-500" />);
      } else if (i === Math.ceil(rating) && !Number.isInteger(rating)) {
        stars.push(<HalfStarIcon key={i} className="w-5 h-5 text-orange-500" />);
      } else {
        stars.push(<StarIcon key={i} className="w-5 h-5 text-gray-300" />);
      }
    }
    return stars;
  };

  useEffect(() => {
    console.log("showSuccessModal1 is now:", showSuccessModal1);
  }, [showSuccessModal1]);

  const closePop = () => {
    setIsPopOpen(false); 
    setShowSuccessModal1(true); 
  };

  return (
    <>
      {isPopOpen && <div className="fixed inset-0 w-full h-full bg-black bg-opacity-40 flex items-center justify-center z-30">
        <div className="bg-white rounded-xl shadow-lg w-full max-w-4xl max-h-[90vh] overflow-y-auto">
          {/* Header */}
          <div className="border-b">
            <div className="flex justify-between items-center mb-3 px-6">
              <h1 className="text-2xl font-bold text-gray-800 pt-4">Review and Ratings</h1>
              <button onClick={() => setIsPopOpen(false)} className="text-gray-400 hover:text-gray-600 border-none outline-none focus:ring-0">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                </svg>
              </button>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 px-6 md:px-8 pt-3">
            {/* Left Column */}
            <div className="lg:col-span-3">
              <div className="flex items-center gap-4">
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6d/Volkswagen_logo_2019.svg/1024px-Volkswagen_logo_2019.svg.png"
                  alt="Company Logo"
                  className="w-16 h-16 rounded-full object-cover border-2 border-gray-200"
                />
                <div>
                  <h2 className="text-xl font-bold text-gray-900">EmayamTechnology. pvt Ltd</h2>
                  <div className="flex items-center mt-1">
                    <span className="bg-cyan-100 text-cyan-800 text-xs font-semibold px-2.5 py-0.5 rounded-full flex items-center gap-1">
                      Premium <PremiumIcon className="w-3 h-3" />
                    </span>
                  </div>
                </div>
              </div>

              <div className="mt-8">
                <h3 className="text-lg font-semibold text-gray-700">Give Ratings For Our Company</h3>
                <div className="flex items-center mt-2">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <button key={star} onClick={() => setUserRating(star)} onMouseEnter={() => setHoverRating(star)} onMouseLeave={() => setHoverRating(0)}>
                      <StarIcon
                        className={`w-7 h-7 cursor-pointer ${star <= (hoverRating || userRating) ? 'text-orange-400' : 'text-gray-300'}`}
                      />
                    </button>
                  ))}
                </div>
                <div className="flex gap-4 mt-2">
                  <a href="#" className="text-sm text-blue-600 hover:underline">Complaints</a>
                  <a href="#" className="text-sm text-blue-600 hover:underline">Feedback</a>
                </div>
              </div>
            </div>

            {/* Right Column */}
            <div className="lg:col-span-2">
              <h3 className="font-semibold text-gray-700">Satisfied Review</h3>
              <div className="flex items-baseline gap-2">
                <span className="text-5xl font-bold text-orange-500">{overallRating.toFixed(1)}</span>
                <span className="text-xl font-medium text-gray-500">/ 5.0</span>
              </div>
              <div className="flex items-center mt-1">{renderDisplayStars(overallRating)}</div>
              <p className="text-sm text-gray-500 mt-2">Total {(totalReviews / 1000).toFixed(1)} k Review</p>
              <div className="mt-6 space-y-3">
                {ratingDistribution.map((item) => (
                  <div key={item.star} className="flex items-center gap-2 text-sm">
                    <span className="w-12 text-gray-600">{item.star} star</span>
                    <div className="w-full bg-gray-200 rounded-full h-2">
                      <div className="bg-orange-500 h-2 rounded-full" style={{ width: `${(item.count / maxCount) * 100}%` }}></div>
                    </div>
                    <span className="w-10 text-right text-gray-600">{item.count}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="px-8 mt-4">
            <label htmlFor="description" className="text-lg font-semibold text-gray-700">Description</label>
            <textarea
              id="description"
              rows="5"
              className="mt-2 w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 transition"
              placeholder="Write a short description about company"
            ></textarea>
          </div>
          <div className="flex justify-end px-8 py-4">
            <button onClick={closePop} className="bg-cyan-500 text-white font-bold py-2 px-8 rounded-lg hover:bg-cyan-600 transition-colors">
              Save
            </button>
          </div>
        </div>
      </div>
      }

      
    </>
  );
};

